import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { closeDialog } from "../../../store/actions";
import { demolishBuilding } from "../../../store/actions/governorate";
import { DragescentState } from "../../../store/reducers/stateType";
import { Slot } from "../../../lib/types";

interface IProps {
  slot: Slot,
  price: { gold: number; bricks: number; powerPoints?: number }
}

const DemolishBuilding = (props: IProps) => {
  const dispatch = useDispatch();
  const castSpells = useSelector((state: DragescentState) => state.governorate.spells.cast);

  const showDragonBreathInfo = () => props.slot.type.id === 26
    && castSpells.some((s: any) => [7, 8, 9].includes(s.id));

  return (
    <>
      <div className="dialog-content">
        <table className="table">
          <tr>
            <td>
              <strong className={"white"}>
                {props.slot.turnsToBuilt === props.slot.type.turns
                  ? <>
                    Do you want to cancel building of
                    <em>{props.slot.type.name}</em> (Immediate and all resources will be returned)?
                  </>
                  : <>
                    Do you want to demolish <em>{props.slot.type.name}</em>?<br/>
                    {showDragonBreathInfo() ? <>
                      You are going to demolish Magic Palace and spell Dragon's Breath is planned.
                      &nbsp;
                      All planned spells will be canceled and spent mana and magic energy returned.
                      <br />
                    </> : ""}
                    <em>{Math.floor(props.price.gold / 2)}</em> <i
                    className={"icon icon-sm icon-zlato gold align-sub"}/>
                    &nbsp;+ <em>{Math.floor(props.price.bricks / 2)}</em> <i
                    className={"icon icon-sm icon-infrastrukturni-body align-sub"}/>
                    &nbsp; will be returned
                  </>}
              </strong>
            </td>
          </tr>
        </table>
      </div>
      <footer className="dialog-footer">
        <a onClick={() => dispatch(closeDialog())} className="btn btn-blank btn-no-width">CANCEL</a>
        <a
          onClick={() => dispatch(demolishBuilding(props.slot.id))}
          className="btn btn-blank btn-no-width"
        >DEMOLISH</a>
      </footer>
    </>
  )
};

export default DemolishBuilding;
